export const camo = [
  {
    number: 'CBB101',
    hasModel: false
  },
{
    number: 'CBB102',
    hasModel: false
  },
  {
    number: 'CBB103',
    hasModel: false
  },
  {
    number: 'CBB104',
    hasModel: false
  },
  {
    number: 'CBB105',
    hasModel: false
  },
  {
    number: 'CBB106',
    hasModel: false
  },
  {
    number: 'CBB107',
    hasModel: false
  },
  {
    number: 'CBB108',
    hasModel: false
  },
  {
    number: 'CBB109',
    hasModel: false
  },

]